module.exports = __webpack_public_path__ + "img/slide-31.b4dcde44.jpeg";